import { useEffect } from 'react';
import { useChakraContext, useMediaQuery } from '@chakra-ui/react';

export function useIsMobileScreenWidth(
  onChangeCallback?: (isMobile: boolean) => void,
): boolean {
  const chakraContext = useChakraContext();
  const lgBreakpoint = chakraContext.breakpoints.values.find(
    (bp) => bp.name === 'lg',
  );
  if (!lgBreakpoint) {
    console.warn(
      'useIsMobileScreenWidth: lg breakpoint not found in chakra context, falling back to 992px',
    );
  }
  const [isMobileScreenWidth] = useMediaQuery([
    `(max-width: ${lgBreakpoint?.max || '992px'})`,
  ]);

  useEffect(() => {
    onChangeCallback?.(isMobileScreenWidth);
  }, [isMobileScreenWidth]);

  return isMobileScreenWidth;
}
